<template>
	<a v-bind:href="item.Url"
	   @click="eventClick(item)"
	   v-bind:target="item.IsExternal ? '_blank' : '_self'"
	   v-bind:class="item.IsFeatured ? 'element-is-featured card card-event card-event--item' : 'card card-event card-event--item'"
	   v-bind:data-category="`${item.Categories}`">
		<div class="card-event-featured" v-if="item.IsFeatured">Featured</div>
		<div class="card-content">
			<div v-bind:class="(item.IsFeatured)?'element-is-featured card-content-title':'card-content-title'">
				<span :class="`icon-event icon-event-${item.Categories[0]}`"></span>
				<div class="card-content-title-wrap">
					<template v-if="item.State && item.City">
						<div class="event-location">
							<span class="event-city">{{ item.City }},</span>
							<span class="event-city">{{ item.State }}</span>

						</div>
					</template>
					<div class="event-title-wrapper">
						<h3 class="event-title" v-if="item.Title">{{ item.EventName }}</h3>
						<template v-if="item.Venue">
							<div class="card-event-venue">{{ item.Venue }}</div>
						</template>
					</div>
					<template v-if="item.DateTBD">
						<span class="card-event-range"><span class="start-date">TBD</span></span>
					</template>
					<template v-else-if="item.StartDate || item.EndDate || item.Recurring || item.DateTextDisplay != '' || item.EventStartTime != ''">
						<p class="card-event-range">
							<template v-if="item.StartDate && !item.EndDate">
								<span class="start-date">{{ formatDateRangeAbv(item.StartDate) }}</span>
							</template>
							<template v-else-if="item.StartDate && item.EndDate">
								<span class="start-end-date">{{ formatDateRangeAbv(item.StartDate, item.EndDate) }}</span>
							</template>
							<template v-else-if="item.IsRecurring && item.DateTextDisplay != ''">
								<span class="recurring-date-text-display">{{ item.DateTextDisplay }}</span>
							</template>
							<template v-else-if="!item.IsRecurring && item.EventStartTime != ''">
								<span class="event-pipe">|</span>
								<span class="recurring-date-text-display">{{ item.EventStartTime }}</span>
							</template>
						</p>
					</template>
					<template v-else-if="!item.StartDate || !item.EndDate || !item.Recurring || item.DateTextDisplay == '' || item.EventStartTime == ''">
						<p class="card-event-range d-none"></p>
					</template>
					<template v-if="displaySummary">
						<p class="card-event-summary">{{ item.Summary }}</p>
					</template>
				</div>
			</div>
			
			<div class="cta-link" v-if="showctatext">View Details</div>
		</div>
	</a>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';
	import analytics from '../../utils/analytics';

	export default {
		props: ['item', 'showctatext', 'displaySummary'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDay(date) {
				return DateFormatService.formatDay(date);
			},
			formatMonth(date) {
				return DateFormatService.formatMonth(date);
			},
			formatDateRange(start, end) {
				return DateFormatService.formatDateRange(start, end);
			},
			formatDateRangeAbv(start, end) {
				return DateFormatService.formatDateRangeAbv(start, end);
			},
			eventClick(item) {
				let data = {
					full_event_name: item.Title,
					event_date: item.DateDisplay,
					event: item.EventName,
					venue: item.Venue,
					location: `${item.City}, ${item.State}`
				};
				analytics.viewEventDetailsClick(data);
			}
        },
    }
</script>